import { openkit } from "../../library/database";

const setProductsAsAvailable = (products) => {
  return products.map((p) => ({ ...p, status: "available" }));
};

export const searchMenus = async (id, info) => {
  try {
    const query = {
      id,
      people: info.restaurant?.people,
      date: info.restaurant?.date,
      service: info.restaurant?.service,
      time: info.restaurant?.time,
    };
    let resp = await openkit.custom.execute("post", "search-menus", null, {
      query,
    });
    // if there's a date, the menus are available at that date, otherwise, it's just a list of menus with non-zero quantity
    if (info.restaurant.date && info.restaurant.time) {
      resp = setProductsAsAvailable(resp);
    }
    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
